module.exports = __webpack_public_path__ + "static/media/kitchen-printer.f1af02f6.svg";